<template>
    <v-dialog v-model="showModalModel" width="500">
        <v-card>
            <v-card-text>
                {{message}}
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="primary"
                    @click.stop="showModalModel = false"
                >
                    {{ 'Continue shopping' | translation }}
                </v-btn>
                <v-spacer />
                <v-btn
                    color="primary"
                    :to="{name: 'basket'}"
                >
                    {{ 'To the basket of gooods' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const parentModuleName = 'Product';
const { mapState, mapMutations } = createNamespacedHelpers(parentModuleName);

export default {
    name: 'InCartModal',
    computed: {
        ...mapState({
            showModal: state => state.showInCartModal,
            message: state => state.inCartMessage
        }),
        showModalModel: {
            get() {
                return this.showModal;
            },
            set(value) {
                this.setShowInCartModal(value);
            }
        }
    },
    methods: {
        ...mapMutations(['setShowInCartModal'])
    }
};
</script>
